export default __webpack_public_path__ + "static/media/affiliates-active.19102d04.svg";